import React, { useRef, useState } from 'react';
import { IconChevronDown } from '../icons';
import Popover from './Popover';
import './search.css';

// Compact single-choice menu button ("Sort: Oldest first"). Portal popover,
// so it works inside narrow scrolling columns.
//   options: [{ value, label, disabled? }]
export default function MenuSelect({ label, value, options, onChange, disabled, title, className }) {
  const [open, setOpen] = useState(false);
  const anchor = useRef(null);
  const opts = options || [];
  const cur = opts.find((o) => o.value === value) || opts[0];
  return (
    <>
      <button
        ref={anchor}
        type="button"
        className={'ss-menubtn' + (className ? ' ' + className : '')}
        aria-haspopup="dialog"
        aria-expanded={open}
        disabled={disabled || opts.length === 0}
        title={title}
        onClick={() => setOpen((o) => !o)}
      >
        {label && <span className="ss-menubtn-label">{label}</span>}
        <span className="ss-menubtn-value">{cur ? cur.label : ''}</span>
        <IconChevronDown size={12} />
      </button>
      <Popover anchorRef={anchor} open={open} onClose={() => setOpen(false)} width={220} label={label || title}>
        <div className="ss-menu-group" role="group" aria-label={label || title}>
          {opts.map((o) => (
            <button
              key={String(o.value)}
              type="button"
              aria-pressed={!!cur && cur.value === o.value}
              className={'ss-menu-item' + (cur && cur.value === o.value ? ' checked' : '')}
              disabled={!!o.disabled}
              onClick={() => {
                setOpen(false);
                if (!cur || cur.value !== o.value) onChange && onChange(o.value);
              }}
            >
              <span className="ss-radio" aria-hidden="true" />
              <span className="ss-menu-text">
                <span>{o.label}</span>
              </span>
            </button>
          ))}
        </div>
      </Popover>
    </>
  );
}
